export default {
    SAVE_REPORTS_DATA: "SAVE_REPORTS_DATA",
    GET_REPORTS_DATA:"GET_REPORTS_DATA",
    DELETE_REPORTS_DATA:"DELETE_REPORTS_DATA"
  };